module.exports = __webpack_public_path__ + "static/img/4-1.7e39d410.png";